import { z } from 'zod';

// Educational session validation schema
export const educationalSessionSchema = z.object({
  sessionType: z.string().optional(),
  groupSessionType: z.string().optional(),
  customEducationalTopic: z.string().optional(),
  groupCustomEducationalTopic: z.string().optional(),
});

// General questionnaire validation schema
export const questionnaireSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().optional(),
  age: z.string().optional(),
  occupation: z.string().optional(),
  relationship: z.string().optional(),
  location: z.string().optional(),
  hobbies: z.string().optional(),
  stressors: z.string().optional(),
  goals: z.string().optional(),
  environment: z.string().optional(),
  useEnvironment: z.boolean().optional(),
  voiceGender: z.enum(['male', 'female']),
  voiceType: z.string().optional(),
  specific_voice_id: z.string().optional(),
  sessionLength: z.union([z.string(), z.number()]),
  backgroundSounds: z.boolean().optional(),
  backgroundMusicSelection: z.union([z.string().min(1, 'Please select a background music option'), z.null()]),
  usePersonalBiography: z.boolean().optional(),
  biography: z.string().optional(),
});

// Category-specific validation schemas
export const zenAfSchema = z.object({
  specificFocus: z.string().min(1, "What's bothering you is required"),
  deeperReason: z.string().min(1, 'Why is required'),
  groupFrustration: z.string().optional(),
  explicitLanguageLevel: z.number().min(1).max(10).optional(),
  humorLevel: z.string().optional(),
});

export const yogaSchema = z.object({
  experienceLevel: z.string().min(1, 'Experience level is required'),
  yogaStyle: z.string().min(1, 'Yoga style is required'),
  beginningPosition: z.string().optional(),
  endingPosition: z.string().optional(),
  focusAreas: z.string().optional(),
  breathWork: z.string().optional(),
  sessionIntention: z.string().optional(),
});